module.exports = __webpack_public_path__ + "static/media/dan-ROJFuWCsfmA-unsplash.424ce8c8.jpg";